import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.MatrixPopupContent.RuleNameButton', {
    addRule: 'Add Auto-Approval Rule',
    placeholder: 'Rule name',
    buttonText: 'Ok',
});
